import ButtonViewProperties from './ButtonViewProperties';

export default ButtonViewProperties;
